<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="!ancillary">
          Questa quietanza non è legata a un titolo: l'incassabilità non è
          applicabile.
        </div>
        <div v-else>
          <!--
            Informativo, non bloccante: da qui l'incassabilità resta sempre modificabile.
            Il vincolo "solo finché non consolidato" vale per la scorciatoia in griglia.
          -->
          <b-alert v-if="isConsolidated" show variant="secondary" class="py-2">
            Titolo consolidato. L'incassabilità resta modificabile da qui.
          </b-alert>
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="">
              <b-row>
                <div class="form-group col-md-4">
                  <base-radio
                    name="to_collect"
                    vid="to_collect"
                    label="Incassabile"
                    v-model="toCollect"
                    :options="to_collect_options"
                  />
                </div>
              </b-row>
              <div class="py-2 mb-4">
                <b-button
                  @click="handleSubmit(onSubmit)"
                  type="button"
                  variant="lisaweb"
                  size="sm"
                >
                  Salva
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import BaseRadio from "@/components/form/BaseRadio";

/*
 * Tab "Incassabile", condiviso dalla modale di dettaglio dei titoli e da quella delle
 * quietanze: il flag è del titolo, quindi si scrive sempre sulla sua risorsa.
 *
 * dbRowData è la riga della griglia che ha aperto la modale: sui titoli è già il titolo,
 * sulle quietanze il titolo arriva come "payable" (per quelle legate a un movimento
 * contabile non c'è titolo, e il tab lo dice).
 *
 * Si usa l'endpoint dedicato e non la update standard: quella pretenderebbe tutti i campi
 * required di InsuranceAncillaryForm e farebbe girare l'observer del titolo, che riscrive
 * premi e stato della polizza e le transizioni di stato delle quietanze.
 */
export default {
  name: "Collect",
  components: { BaseRadio },
  props: {
    resourceId: Number,
    dbRowData: Object,
  },
  data() {
    return {
      isLoading: false,
      toCollect: null,
      to_collect_options: [
        { value: "Y", text: "Si" },
        { value: "N", text: "No" },
      ],
    };
  },
  computed: {
    ancillary() {
      const row = this.dbRowData;
      if (!row) return null;
      const candidate = row.to_collect ? row : row.payable;
      return candidate && candidate.to_collect ? candidate : null;
    },
    isConsolidated() {
      return this.ancillary?.consolidated?.value === "Y";
    },
  },
  created() {
    this.toCollect = this.ancillary?.to_collect?.value ?? null;
  },
  methods: {
    onSubmit() {
      this.isLoading = true;
      const Repo = RepositoryFactory.get("insurance_ancillary");
      Repo.to_collect_update(this.ancillary.id, { to_collect: this.toCollect })
        .then(() => {
          /* Allinea la riga della griglia senza rifare la fetch */
          this.ancillary.to_collect.value = this.toCollect;
          this.ancillary.to_collect.text =
            this.toCollect === "Y" ? "Sì" : "No";
          this.$showSnackbar({
            preset: "success",
            text: `Incassabilità del titolo aggiornata`,
          });
          this.$emit("fetch");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
